export default __webpack_public_path__ + "static/media/upi-icon.1c46f5f5.svg";